"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComparisonDateRange = exports.mapRolesToValues = exports.getLatestValue = void 0;
var d3array = require("d3-array");
var models_1 = require("./models");
var Accessor_1 = require("./models/Accessor");
var DataTable_1 = require("./models/DataTable");
var getLatestValue = function (table, accessor) {
    if (accessor === void 0) { accessor = Accessor_1.DefaultMeasureAccessor; }
    if (table && table.length) {
        for (var i = table.length - 1; i > -1; i--) {
            var point = table[i];
            var value = accessor(point);
            if (!(0, DataTable_1.isNullOrUndefined)(value)) {
                return point;
            }
        }
    }
    return undefined;
};
exports.getLatestValue = getLatestValue;
var mapRolesToValues = function (roles, value, comparison) {
    return roles
        .map(function (role) {
        switch (role) {
            case models_1.MetricValueRole.CURRENT:
                return { role: role, value: value };
            case models_1.MetricValueRole.ABSOLUTE_CHANGE:
                return comparison ? { role: role, value: comparison.absolute } : undefined;
            case models_1.MetricValueRole.PERCENTAGE_CHANGE:
                return comparison ? { role: role, value: comparison.percentage } : undefined;
            default:
                return undefined;
        }
    })
        .filter(function (element) { return element !== undefined; });
};
exports.mapRolesToValues = mapRolesToValues;
var getComparisonDateRange = function (data) {
    var _a = d3array.extent(data, function (p) { return p.comparisonTimestamp; }), first = _a[0], last = _a[1];
    if (first && last) {
        return { first: first, last: last };
    }
    return undefined;
};
exports.getComparisonDateRange = getComparisonDateRange;
//# sourceMappingURL=engine.js.map